import { t } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { Text } from '@lune-fe/lune-ui-lib'
import { ReactNode } from 'react'

export const InputsWrapper = ({ children }: { children: ReactNode }) => {
    useLingui()

    return (
        <>
            <Text variant={'h5'} sx={{ mb: 4 }}>
                {t`Your inputs`}
            </Text>
            {children}
        </>
    )
}

export const InputWrapper = ({ children }: { children: ReactNode }) => {
    useLingui()

    return (
        <>
            <Text variant={'h5'} sx={{ mb: 4 }}>
                {t`Your input`}
            </Text>
            {children}
        </>
    )
}

export default InputsWrapper
